import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from 'store';
import theme from 'theme';

import { MuiThemeProvider } from '@material-ui/core/styles';
import * as Sentry from '@sentry/react';

import pkjson from '../package.json';
import App from './App';
import * as serviceWorker from './serviceWorker';

const APP_NAME = `${pkjson.name}@${pkjson.version}`;

if (process.env.NODE_ENV === 'production') {
	Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN, release: APP_NAME });
}

ReactDOM.render(
	<React.StrictMode>
		<MuiThemeProvider theme={theme}>
			<Provider store={store}>
				<App />
			</Provider>
		</MuiThemeProvider>
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
